<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex sm12>
                    <h3>درخواست تسویه</h3>
                </v-flex>
            </v-layout>
            <v-flex lg12>
                <v-card>
                    <v-card-text class="pa-3">
                        <v-layout>
                            <v-flex sm12>

                                <v-chip>تعداد آیتم‌های قابل تسویه {{toPersianDigit(settable.quantity)}} عدد</v-chip>
                                <v-chip>مبلغ کل قابل تسویه:
                                    {{moneyFormat(settable.commission)}} ریال</v-chip>
                            </v-flex>
                            <v-flex sm12 v-if="settable.commission > 0">
                                <v-btn
                                        v-if="settable.commission >= settable.min_banking"
                                        color="green"
                                        class="white--text"
                                        large
                                        round
                                        type="button"
                                        @click="banking"
                                >
                                    تسویه‌ی با شبای بانکی
                                    &nbsp;
                                    <v-icon left dark>account_balance</v-icon>
                                </v-btn>
                                <v-btn
                                        v-else
                                        disabled
                                        class="white--text"
                                        large
                                >
                                  کمترین میزان مجاز برای تسویه‌ی بانکی {{moneyFormat(settable.min_banking)}}ریال میباشد.
                                    &nbsp;
                                    <v-icon left dark>account_balance</v-icon>
                                </v-btn>

                                <v-btn
                                        color="blue"
                                        class="white--text"
                                        large
                                        round
                                        type="button"
                                        @click="internal"
                                >
                                    تسویه‌ در موجودی حساب کاربری
                                    &nbsp;
                                    <v-icon left dark>account_balance_wallet</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>

                    </v-card-text>
                </v-card>
            </v-flex>
        </v-container>

        <v-container grid-list-xl fluid v-if="complex.items.length > 0">
            <v-layout row wrap>
                <v-flex sm12>
                    <h3>تاریخچه‌ی تسویه حسابها</h3>
                </v-flex>
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                    flat
                                    solo
                                    prepend-icon="search"
                                    placeholder="جستجو..."
                                    v-model="search"
                                    hide-details
                                    class="hidden-sm-and-down"
                            ></v-text-field>
                            <v-btn icon>
                                <v-icon>filter_list</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="complex.headers"
                                    :search="search"
                                    :items="complex.items"
                                    :rows-per-page-items="[25,50,100,500,{text:'همه','value':-1}]"
                                    class="elevation-1"
                                    item-key="Name"
                                    select-all
                                    v-model="complex.selected"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-center">
                                        <v-checkbox
                                                primary
                                                hide-details
                                                v-model="props.selected"
                                        ></v-checkbox>
                                    </td>
                                    <td class="text-xs-center">{{ toPersianDigit(props.item.ref_id,false) }}</td>
                                    <td class="text-xs-center">{{ toPersianDigit(props.item.shaba,false) }}</td>
                                    <td class="text-xs-center">{{ moneyFormat(props.item.amount) }}</td>
                                    <td class="text-xs-center">
                                        <v-chip color="orange" text-color="white" v-if="props.item.completed === 'No'">
                                            درحال انجام
                                        </v-chip>
                                        <v-chip color="green" text-color="white" v-else> انجام شده</v-chip>
                                    </td>
                                    <td class="text-xs-center">{{ props.item.description }}</td>
                                    <td class="text-xs-center">{{ toPersianDigit(props.item.transaction_id,false) }}
                                    </td>
                                    <td class="text-xs-center" style="direction: ltr">{{ toJalali(props.item.created_at)
                                        }}
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-snackbar
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    :top="snackbar.y === 'top'"
                    :bottom="snackbar.y === 'bottom'"
                    :right="snackbar.x === 'right'"
                    :left="snackbar.x === 'left'"
                    :multi-line="snackbar.mode === 'multi-line'"
                    :vertical="snackbar.mode === 'vertical'"
                    v-model="snackbar.snackbar"
            >
                {{ snackbar.text }}
                <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-container>
    </div>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';

export default {
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'شماره تسویه',
            value: 'ref_id',
            align: 'center'
          },
          {
            text: 'شماره حساب/شبا',
            value: 'shaba',
            align: 'center'
          },
          {
            text: 'مبلغ(﷼)',
            value: 'amount',
            align: 'center'
          },
          {
            text: 'وضعیت',
            value: 'completed',
            align: 'center'
          },
          {
            text: 'توضیحات',
            value: 'description',
            align: 'center'
          },
          {
            text: 'شماره تراکنش',
            value: 'transaction_id',
            align: 'center'
          },
          {
            text: 'تاریخ ثبت',
            value: 'created_at',
            align: 'center'
          }
        ],
        items: []
      },
      settable: {
        min_banking: 100,
        quantity: 0,
        commission: 0
      }
    };
  },
  created: function () {

    this.axios.get('/reseller/refinances/')
      .then(response => {
        this.complex.items = response.data.Data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    // get settable items
    this.axios.get('/reseller/settable_items')
      .then(response => {
        this.settable = response.data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  },
  methods: {
    banking: function () {
      this.$confirm('این عملیات غیر قابل بازگشت است. آیا از انجام این کار اطمینان دارید؟').then(res => {
        if (res) {
          this.axios.get('/reseller/settle_items/banking')
            .then(response => {
              this.snackbar.snackbar = true;
              this.snackbar.color = 'success';
              this.snackbar.text = 'با موفقیت انجام شد';
            })
            .catch(error => {
              this.snackbar = HttpErrorToSnackbar(error);
            });
        }
      });
    },
    internal: function () {
      this.$confirm('مبلغ درآمد در حساب کاربری غیرقابل عودت است. آیا از انجام این کار اطمینان دارید؟').then(res => {
        if (res) {
          this.axios.get('/reseller/settle_items/internal')
            .then(response => {
              this.snackbar.snackbar = true;
              this.snackbar.color = 'success';
              this.snackbar.text = 'با موفقیت انجام شد';
            })
            .catch(error => {
              this.snackbar = HttpErrorToSnackbar(error);
            });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/commission/refinances.vue